// Svelte 5 no longer needs svelte/store imports for basic reactivity

function loadCliConfigFromLocalStorage() {
    let cliConfig = JSON.parse(localStorage.getItem("cc-cli-configs")) || [
        {
            name: "Drastic Technologies",
            modalName: "drasticTech",
            options: [
                {
                    name: "Enable",
                    type: "list-input",
                    values: ["true", "false"],
                    selected: "false"
                },
                {
                    name: "CC Embed",
                    type: "file-input",
                    values: [],
                    selected: ""
                },
                {
                    name: "CC Extract",
                    type: "file-input",
                    values: [],
                    selected: ""
                }
            ]
        }
    ];
    
    return cliConfig;
}

// Create reactive state for CLI configuration
export const cliConfigState = $state(loadCliConfigFromLocalStorage());

// Function to save CLI config to localStorage
export function saveCliConfig() {
    localStorage.setItem("cc-cli-configs", JSON.stringify(cliConfigState));
}